import { createFileRoute } from "@tanstack/react-router";
import ComparisonsHubPage from "@/pages/comparisons/ComparisonsHubPage";

export const Route = createFileRoute("/comparaisons/")({
  component: ComparisonsHubPage,
});
